"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TPC = _interopRequireDefault(require("./SubmissionTermsCopy/TPC"));
var _TiH = _interopRequireDefault(require("./SubmissionTermsCopy/TiH"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SubmissionTerms = function SubmissionTerms(props) {
  switch (props.site) {
    case "The Pet Collective":
      return /*#__PURE__*/_react["default"].createElement(_TPC["default"], null);
    case "This is Happening":
      return /*#__PURE__*/_react["default"].createElement(_TiH["default"], null);
    default:
      return "";
  }
};
var _default = SubmissionTerms;
exports["default"] = _default;